import { Component, OnInit, Input } from '@angular/core';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';
import { CommercialService } from '../../commercial.service';

@Component({
  selector: 'app-cq9',
  templateUrl: './cq9.component.html',
  styleUrls: ['./cq9.component.css', '../commercial-questionnaire.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ])
  ]
})
export class Cq9Component implements OnInit {

  @Input() data: any;
  question;
  questions;
  user_bot = false;
  showbutton = true;
  userResponses = [];
  index;
  questionObj;
  deviceWidth;
  service1_id;
  service2_id;
  service;
  sp_src;
  ns_src;
  isChecked;
  hgService = {
    ns: false,
    sp: false
  };
  timer;
  location_services = [];
  time = 3000;
  showTyping = false;

  constructor(private commercialService: CommercialService) {
    this.questions = this.commercialService.getQues();
    this.deviceWidth = this.commercialService.deviceWidth;
    this.userResponses = this.commercialService.userResponse.userResponses;
  }

  ngOnInit() {
    this.commercialService.currentId = this.data;
    if (this.deviceWidth < 768) {
      this.service1_id = document.getElementById('NewService_mob');
      this.service2_id = document.getElementById('SwitchingProviders_mob');
    } else {
      this.service1_id = document.getElementById('NewService');
      this.service2_id = document.getElementById('SwitchingProviders');
    }

    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].com_question;
        this.questionObj = this.questions[i];
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'com_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.location_services = obj.fieldValue;
        if (!this.commercialService.addAddress && !_.isEmpty(this.location_services)) {
          let index;
          if (this.commercialService.serialNumber !== null) {
            index = this.commercialService.serialNumber;
          } else if (this.commercialService.serialNumber === null) {
            index = 0;
          }
          if (!_.isEmpty(this.location_services[index])) {
            this.service = this.location_services[index].value;
            if (!_.isEmpty(this.service)) {
              this.isChecked = true;
              this.commercialService.setServiceType(this.service);
              if (this.service === 'New Service') {
                this.ns_src = 'assets/images/new-service-purple.png';
                this.sp_src = 'assets/images/switch-providers-gray.png';
                this.hgService = {
                  ns: true,
                  sp: false
                };
                this.service1_id.parentElement.parentElement.classList.add('active-select');
              } else if (this.service === 'Switching Providers') {
                this.ns_src = 'assets/images/new-service-gray.png';
                this.sp_src = 'assets/images/switch-providers-purple.png';
                this.hgService = {
                  ns: false,
                  sp: true
                };
                this.service2_id.parentElement.parentElement.classList.add('active-select');
              }
              this.user_bot = true;
              if (this.deviceWidth < 768) {
                if (this.commercialService.modifyAddress) {
                  this.typingNext();
                } else {
                  this.next();
                }
              }
            } else {
              this.sp_src = 'assets/images/switch-providers-gray.png';
              this.ns_src = 'assets/images/new-service-gray.png';
            }
          } else {
            this.sp_src = 'assets/images/switch-providers-gray.png';
            this.ns_src = 'assets/images/new-service-gray.png';
          }
        } else {
          this.sp_src = 'assets/images/switch-providers-gray.png';
          this.ns_src = 'assets/images/new-service-gray.png';
        }
      } else {
        this.sp_src = 'assets/images/switch-providers-gray.png';
        this.ns_src = 'assets/images/new-service-gray.png';
      }
    } else {
      this.sp_src = 'assets/images/switch-providers-gray.png';
      this.ns_src = 'assets/images/new-service-gray.png';
    }

    if(!this.hgService.ns && !this.hgService.sp)
    {
      this.showbutton = false;
    }
  }

  typingNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.commercialService.unSelectService({'currentId': this.data});
      this.showTyping = true;
      this.timer = setTimeout(() => {
        this.showTyping = false;
        this.next();
      }, this.time);
    }
  }

  getService(event) {
    this.service = event.target.value;
    this.isChecked = event.target.checked;
    this.user_bot = true;
    if (this.isChecked === true) {
      if (this.service === 'New Service') {
        this.ns_src = 'assets/images/new-service-purple.png';
        this.sp_src = 'assets/images/switch-providers-gray.png';
        if (_.contains(this.service2_id.parentElement.parentElement.classList, 'active-select')) {
          this.service2_id.parentElement.parentElement.classList.remove('active-select');
        }
        this.service1_id.parentElement.parentElement.classList.add('active-select');
        this.hgService = {
          ns: true,
          sp: false
        };
      } else {
        this.ns_src = 'assets/images/new-service-gray.png';
        this.sp_src = 'assets/images/switch-providers-purple.png';
        if (_.contains(this.service1_id.parentElement.parentElement.classList, 'active-select')) {
          this.service1_id.parentElement.parentElement.classList.remove('active-select');
        }
        this.service2_id.parentElement.parentElement.classList.add('active-select');
        this.hgService = {
          ns: false,
          sp: true
        };
      }
    } else {
      this.sp_src = 'assets/images/switch-providers-gray.png';
      this.ns_src = 'assets/images/new-service-gray.png';
      this.hgService = {
        ns: false,
        sp: false
      };
      this.service = '';
      this.user_bot = false;
      if (_.contains(this.service1_id.parentElement.parentElement.classList, 'active-select')) {
        this.service1_id.parentElement.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.service2_id.parentElement.parentElement.classList, 'active-select')) {
        this.service2_id.parentElement.parentElement.classList.remove('active-select');
      }
    }
    this.save();
    if (this.deviceWidth < 768) {
      this.goNext();
    }

    if (this.isChecked === true)
    {
      if (this.deviceWidth < 768) {
       
      }else
      {
        if(!this.showbutton)
        {
          this.next();
        }
  
      }

    }

  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 1000);
    }
  }

  next() {
    if (_.isEmpty(this.service)) {
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({'currentId': this.data});
      }
    } else {
      this.commercialService.setServiceType(this.service);
      this.commercialService.messageService({ 'currentId': this.data, 'service': this.service });
    }
  }

  // This function is used for to save the data in DB
  save() {
    let index;
    if (this.commercialService.serialNumber === null) {
      index = this.location_services.length;
    } else {
      index = this.commercialService.serialNumber;
    }
    this.location_services[index] = { 'serialNo': index + 1, 'value': this.service };
    const Obj = {
      'com_question_id': this.data,
      'fieldName': 'service',
      'fieldValue': this.location_services
    };
    this.commercialService.updateResponses(Obj);
  }

}
